import type { DeploymentEnvironment } from '@dev-console/types';

import { StatusBadge } from '@/components/ui/status-badge';

const JOBS_DB_ENVIRONMENT_OPTIONS = ['production', 'staging'] as const satisfies readonly DeploymentEnvironment[];

export const jobsDbEnvironmentParamDef = {
  default: 'production' as DeploymentEnvironment,
  parse: (raw: string): DeploymentEnvironment => (raw === 'staging' ? 'staging' : 'production'),
};

export function JobsDbEnvironmentToggle({
  value,
  onChange,
}: {
  value: DeploymentEnvironment;
  onChange: (env: DeploymentEnvironment) => void;
}) {
  return (
    <div
      role='group'
      aria-label='Jobs DB environment'
      className='inline-flex rounded-md border border-neutral-200 bg-white p-0.5'
    >
      {JOBS_DB_ENVIRONMENT_OPTIONS.map((option) => {
        const selected = value === option;

        return (
          <button
            key={option}
            aria-pressed={selected}
            className={`rounded px-3 py-1 text-xs font-medium capitalize ${
              selected
                ? option === 'staging'
                  ? 'bg-amber-500 text-white'
                  : 'bg-neutral-900 text-white'
                : 'text-neutral-600 hover:bg-neutral-50 hover:text-neutral-900'
            }`}
            onClick={() => onChange(option)}
            type='button'
          >
            {option}
          </button>
        );
      })}
    </div>
  );
}

export function JobsDbEnvironmentBadge({ environment }: { environment: DeploymentEnvironment }) {
  if (environment !== 'staging') return null;

  return <StatusBadge status='staging' label='Staging' colors={{ staging: 'bg-amber-100 text-amber-800' }} />;
}
